import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { adminGetGiftSettings, adminSaveGiftSettings, isOk, messageOf } from "../../../services/gift";

// Admin: gift creation fee (charged to the purchaser on VerySoul's account).
// Applies to new gifts only; each gift keeps the fee it was created with.
export default function AdminGiftSettings() {
  const [settings, setSettings] = useState(null);
  const [fee, setFee] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminGetGiftSettings().then((res) => {
      if (isOk(res)) {
        setSettings(res.data.data);
        setFee(Number(res.data.data.fee).toFixed(2));
      }
    });
  }, []);

  const save = async (e) => {
    e.preventDefault();
    const value = Number(fee);
    if (!fee || isNaN(value) || value < settings.fee_min || value > settings.fee_max) {
      toast.error(`Enter a fee between ${settings.fee_min.toFixed(2)} and ${settings.fee_max.toFixed(2)}.`, { position: "top-center" });
      return;
    }
    setSaving(true);
    const res = await adminSaveGiftSettings(value);
    setSaving(false);
    if (isOk(res)) {
      setSettings({ ...settings, fee: res.data.data.fee });
      setFee(Number(res.data.data.fee).toFixed(2));
      toast.success(messageOf(res, "Saved."), { position: "top-center" });
    } else {
      toast.error(messageOf(res, "The fee could not be saved."), { position: "top-center" });
    }
  };

  if (!settings) {
    return null;
  }

  return (
    <form className="admin-gift-settings" onSubmit={save}>
      <div>
        <b>Gift creation fee</b>
        <p className="admin-gifts-muted mb-0">
          Non-refundable fee the purchaser pays to create a gift. Applies to new gifts only. Default from
          configuration: {settings.currency} {Number(settings.default_fee).toFixed(2)}.
        </p>
      </div>
      <div className="admin-gift-settings-input">
        <span>{settings.currency}</span>
        <input
          className="form-control"
          type="number"
          step="0.01"
          min={settings.fee_min}
          max={settings.fee_max}
          value={fee}
          onChange={(e) => setFee(e.target.value)}
        />
        <button type="submit" className="proceed-btn" disabled={saving}>
          {saving ? "Saving…" : "Save"}
        </button>
      </div>
    </form>
  );
}
